import { makeAutoObservable } from "mobx";

export default class BasketStore {
    constructor() {
        this._basketItems = JSON.parse(localStorage.getItem('basketItems')) || [];
        this._totalPrice = 0;
        makeAutoObservable(this);
        this._updateTotalPrice();
    }

    setBasketItems(items) {
        this._basketItems = items || [];
        this._updateLocalStorage();
        this._updateTotalPrice();
    }

    addBasketItem(item) {
        const existingItem = this._basketItems.find(i => i.id === item.id);
        if (existingItem) {
            existingItem.quantity = (existingItem.quantity || 1) + 1;
        } else {
            this._basketItems.push({ ...item, quantity: 1 });
        }
        this._updateLocalStorage();
        this._updateTotalPrice();
    }

    removeBasketItem(itemId) {
        this._basketItems = this._basketItems.filter(item => item.id !== itemId);
        this._updateLocalStorage();
        this._updateTotalPrice();
    }

    incrementQuantity(itemId) {
        const item = this._basketItems.find(i => i.id === itemId);
        if (item) {
            item.quantity = (item.quantity || 1) + 1;
            this._updateLocalStorage();
            this._updateTotalPrice();
        }
    }

    decrementQuantity(itemId) {
        const item = this._basketItems.find(i => i.id === itemId);
        if (item && item.quantity > 1) {
            item.quantity -= 1;
            this._updateLocalStorage();
            this._updateTotalPrice();
        }
    }

    clearBasket() {
        this._basketItems = [];
        this._totalPrice = 0;
        this._updateLocalStorage();
    }

    _updateTotalPrice() {
        this._totalPrice = this._basketItems.reduce((sum, item) => 
            sum + item.price * (item.quantity || 1), 0);
    }

    _updateLocalStorage() {
        localStorage.setItem('basketItems', JSON.stringify(this._basketItems));
    }

    get basketItems() {
        return this._basketItems;
    }

    get totalPrice() {
        return this._totalPrice;
    }
}